<script setup>
import { computed } from 'vue';
import { useStore } from 'vuex';
import PipelineColumn from './PipelineColumn.vue';

const store = useStore();

const conversationsByStage = computed(
  () => store.getters['pipeline/getConversationsByStage']
);
const totalsByStage = computed(
  () => store.getters['pipeline/getTotalsByStage']
);
const stages = computed(() => store.getters['pipeline/getStages']);
const isUpdating = computed(
  () => store.getters['pipeline/getUIFlags'].isUpdating
);

const handleMove = async ({ conversation, fromStage, toStage }) => {
  try {
    await store.dispatch('pipeline/updateStage', {
      conversationId: conversation.display_id,
      stage: toStage,
      fromStage,
    });
  } catch (error) {
    // Error handling is done by the API layer
  }
};
</script>

<template>
  <!--
    Mobile (< md): a página rola e cada estágio tem teto de 70vh, rolando por dentro.
    Sem isso, `h-full` divide a altura igualmente entre os estágios empilhados (~170px cada
    numa tela de 882px), a lista estoura o `min-h-[200px]` e vaza por cima do próximo cabeçalho.
    De md pra cima as colunas ficam lado a lado e a altura cheia volta a valer.
  -->
  <div
    class="h-full w-full max-w-[66rem] mx-auto px-6 py-6 overflow-y-auto md:overflow-hidden"
  >
    <div
      class="grid gap-4 w-full h-auto md:h-full"
      :class="{
        'grid-cols-1': stages.length === 1,
        'grid-cols-1 md:grid-cols-2': stages.length === 2,
        'grid-cols-1 md:grid-cols-2 lg:grid-cols-3': stages.length === 3,
        'grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4':
          stages.length === 4,
        'grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-5':
          stages.length === 5,
        'grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-6':
          stages.length === 6,
      }"
    >
      <div
        v-for="stage in stages"
        :key="stage.id"
        class="flex flex-col min-h-0 max-h-[70vh] md:max-h-none"
      >
        <PipelineColumn
          :stage="stage"
          :conversations="conversationsByStage[stage.id] || []"
          :total="totalsByStage[stage.id]"
          :is-updating="isUpdating"
          @update:conversations="() => {}"
          @move="handleMove"
        />
      </div>
    </div>
  </div>
</template>
